import {
    CONFIRMED_CREATE_CATEGORY_ACTION,
    CONFIRMED_DELETE_CATEGORY_ACTION,
    CONFIRMED_EDIT_CATEGORY_ACTION,
    CONFIRMED_GET_CATEGORIES,
    CREATE_CATEGORY_ACTION,    
    CREATE_CATEGORY_ERROR_ACTION,
    CLEAR_CATEGORY_ERROR,
    LOADING_TOGGLE_ACTION
} from '../actions/CategoryTypes';

const initialState = {
    categories: [],
    loading: false,
    createCategoryError:{}
   
};

export default function CategoryReducer(state = initialState, actions) {

    if (actions.type === CREATE_CATEGORY_ACTION) {        
        const categories = [...state.categories];     
       
        return {
            ...state,
            categories,
        };
    }

    if (actions.type === CONFIRMED_DELETE_CATEGORY_ACTION) {
        const categories = [...state.categories];
        const postIndex = categories.findIndex(
            (post) => post.id === actions.payload,
        );
        categories.splice(postIndex, 1);

        return {
            ...state,
            categories,
        };
    }

    if (actions.type === CONFIRMED_EDIT_CATEGORY_ACTION) {
        const categories = [...state.categories];
        const postIndex = categories.findIndex(
            (post) => post.id === actions.payload.id,
        );
        categories[postIndex] = actions.payload;       
        return {
            ...state,
            categories,
        };
    }

    if (actions.type === CONFIRMED_CREATE_CATEGORY_ACTION) {
        const categories = [...state.categories];
        categories.push(actions.payload);
        return {
            ...state,
            categories,
        };
    }

    if (actions.type === CONFIRMED_GET_CATEGORIES) {
        return {
            ...state,
            categories: actions.payload,
        };
    }
    if (actions.type === CREATE_CATEGORY_ERROR_ACTION) {
        return {
            ...state,
            createCategoryError: actions.payload,
        };
    }

    if (actions.type === CLEAR_CATEGORY_ERROR) {
        return {
            ...state,
            createCategoryError: {},
        };
    }
     if (actions.type === LOADING_TOGGLE_ACTION) {
            return {
                ...state,
                loading: actions.payload,
            };
    }
    return state;
}


